"use client";

import { gsap } from "gsap";
import { ImageAsset } from "../../../sanity/lib/types/imageAsset";
import { ScrollTrigger } from "gsap/all";
import { useRef } from "react";
import { ImageElement } from "../Image";
import { useGSAP } from "@gsap/react";

gsap.registerPlugin(ScrollTrigger);

export const ImageCollageMobile = ({ mobileImages }: { mobileImages?: Array<ImageAsset> }) => {
    const containerRef = useRef<HTMLDivElement>(null);

    useGSAP(
        () => {
            gsap.fromTo(
                ".mobile-image:not(:first-child)",
                {
                    y: "100%",
                    transformOrigin: "bottom center",
                },
                {
                    y: 0,
                    stagger: {
                        each: 0.5,
                    },
                    scrollTrigger: {
                        pin: ".mobile-images",
                        scrub: true,
                        start: "center 50%",
                        end: "bottom top",
                        invalidateOnRefresh: true,
                    },
                },
            );
        },

        { scope: containerRef },
    );

    return (
        <div className="container relative" ref={containerRef}>
            <div className="mx-2.5 md:mx-5">
                <div className="relative w-full overflow-hidden max-h-dvh mobile-images">
                    {mobileImages?.map(
                        (image, index) =>
                            image.image?.asset?._ref && (
                                <ImageElement
                                    key={index}
                                    width={800}
                                    src={image.image}
                                    alt={image.alt || ""}
                                    className={`max-h-dvh absolute mobile-image top-0 left-0 w-full h-auto object-cover aspect-[375/463] ${index === 0 && "relative"}`}
                                />
                            ),
                    )}
                </div>
            </div>
        </div>
    );
};
